import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgxPermissionsModule } from 'ngx-permissions';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import './resources/workspaces.resource';
import { WorkspacesListComponent } from './components/workspaces-list.component';
import { WorkspaceListItemComponent } from './components/workspace-list-item.component';
import { WorkspaceFormComponent } from './components/workspace-form.component';
import { workspacesReducer } from './store/workspaces.reducer';
import { WorkspacesEffects } from './store/workspaces.effects';
import { CommonModule } from '../common/common.module';
import { WorkspacesComponent } from './workspaces.component';

@NgModule({
  declarations: [WorkspacesListComponent, WorkspaceListItemComponent, WorkspaceFormComponent, WorkspacesComponent],
  imports: [
    BrowserModule,
    FormsModule,
    StoreModule.forFeature('workspaces', workspacesReducer),
    EffectsModule.forFeature([WorkspacesEffects]),
    CommonModule,
    TranslateModule,
    NgxPermissionsModule,
    MatTooltipModule,
    MatMenuModule,
  ],
  providers: [provideHttpClient(withInterceptorsFromDi())],
})
export class WorkspacesModule {}
